var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon15(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_9610)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.75 10.1719C15.881 10.1719 13.5469 12.506 13.5469 15.375C13.5469 16.3253 13.8031 17.2168 14.2499 17.9843L12.7031 19.1874V10.3586C15.2408 10.0142 17.2031 7.8337 17.2031 5.20312C17.2031 2.33409 14.869 0 12 0C9.13097 0 6.79688 2.33409 6.79688 5.20312C6.79688 7.8337 8.75925 10.0142 11.2969 10.3586V19.1874L9.75009 17.9843C10.1969 17.2168 10.4531 16.3253 10.4531 15.375C10.4531 12.506 8.11903 10.1719 5.25 10.1719C2.38097 10.1719 0.046875 12.506 0.046875 15.375C0.046875 18.244 2.38097 20.5781 5.25 20.5781C6.66347 20.5781 7.94686 20.0113 8.88553 19.0934L11.2969 20.9689V22.5938H9C8.61169 22.5938 8.29688 22.9086 8.29688 23.2969C8.29688 23.6852 8.61169 24 9 24H15C15.3883 24 15.7031 23.6852 15.7031 23.2969C15.7031 22.9086 15.3883 22.5938 15 22.5938H12.7031V20.9689L15.1145 19.0934C16.0531 20.0113 17.3365 20.5781 18.75 20.5781C21.619 20.5781 23.9531 18.244 23.9531 15.375C23.9531 12.506 21.619 10.1719 18.75 10.1719Z",
    fill: "#C32A7C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_9610"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon15);
export default __webpack_public_path__ + "static/media/icon15.239085aa92b76be283f8e397d04eda1d.svg";
export { ForwardRef as ReactComponent };